import { cn } from '@client/lib';
import { useProgressBarStepState } from './hooks/useProgressBarStepState';

interface ProgressBarStepItemProps {
  step: { id: number; name: string };
  currentProgressStep: number;
  currentStep: LtcFinancialPlanningStep;
}

export function ProgressBarStepItem({
  step,
  currentProgressStep,
  currentStep,
}: ProgressBarStepItemProps) {
  const { progressPercent, textColorClass } = useProgressBarStepState({
    stepId: step.id,
    currentProgressStep,
    currentStep,
  });

  return (
    <li className="flex flex-1 flex-col items-center">
      {/* Progress Bar Above Label */}
      <div className="mb-3 w-full max-w-[200px]">
        <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="bg-primary h-full rounded-full transition-[width] duration-300 ease-out"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
      </div>

      {/* Step Label Below */}
      <span
        className={cn('text-nowrap text-center text-xs font-medium md:text-sm', textColorClass)}
      >
        {step.name}
      </span>
    </li>
  );
}
